import { ArrowBack, CopyAllOutlined } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { Link } from "react-admin";
import { useState } from "react";
import {
  Button,
  CheckboxGroupInput,
  DateInput,
  Edit,
  EditButton,
  required,
  SelectInput,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSave from "../../unit/CustomButtonSave";
import HmTextInput from "../../unit/HmTextInput";
import useNotify from "../../unit/useNotify";
import React from "react";
import { format } from "date-fns";
import formatPhone from "../../unit/inputFormat/formatPhone";
import parsePhone from "../../unit/inputFormat/parsePhone";
import YesNoInput3 from "../../unit/YesNoInput3";
import HeaderLabelGridField from "../../unit/HeaderLabelGridField";

import TaskAltIcon from "@mui/icons-material/TaskAlt";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
const EditToolbar = (props: any) => {
  const { reset } = useFormContext();
  const { success, error, info } = useNotify();
  const { getValues, formState } = useFormContext();
  const isDirty = formState.isDirty;

  const record = useRecordContext();
  const id = record?.id;
  const handleUndo = () => {
    reset();
    //set isDirty to false
    success("Changes have been cancel");
  };

  const saveData = () => {
    const reqUrl = "banks/actions/edit";

    const formData = isDirty ? getValues() : null;
    if (formData) {
      const saveFormData = {
        phone: formData.sBankPhone,
        bank_email: formData.sBankSupport,
        contactName: formData.sBankContactName,
        textMessageNumber: formData.textMessageNumber,
        textMessageInstruction: formData.textMessageInstruction,
        saveType: "contact",
      };
      if (!saveFormData?.phone) {
        error("Contact Phone Number is required");
        return;
      }
      if (!saveFormData?.bank_email) {
        error("Contact Email Address is required");
        return;
      }
      if (!saveFormData?.contactName) {
        error("Contact Name is required");
        return;
      }

      sendRequest(reqUrl, { id: id, data: saveFormData }).then((res) => {
        if (res?.code == 200) {
          success("Saved successfully");
          reset(formData);
        } else {
          error("Error saving " + res?.message);
        }
      });
    } else {
      error("Error saving description: No data to save");
    }
  };
  return (
    <Box
      sx={{
        display: "block",
        mt: "2px",
        borderRadius: "0px",
        paddingTop: "0px",
      }}
    >
      <Toolbar
        {...props}
        sx={{
          background: "#fff",
          justifyContent: "space-between",
          // border: "1px solid red",
          borderTop: "1px solid #e0e0e0",
          padding: "0px",
          marginTop: "10px",
          "&.MuiToolbar-root.RaToolbar-root": {
            paddingLeft: "0px",
            paddingRight: "0px",
          },
        }}
      >
        <CustomButtonCancel label="Undo" onClick={handleUndo} />
        {/* <SaveButton /> */}
        <CustomButtonSave
          variant="contained"
          color="primary"
          onClick={saveData}
          disabled={!isDirty}
          sx={{
            width: "120px",
          }}
        />
      </Toolbar>
    </Box>
  );
};

const AccessEditForm = ({ isEdit = false, admin = false }) => {
  const record = useRecordContext();
  const { success, error, info } = useNotify();
  if (!record) return <div>Loading...</div>;
  const sendRequestToAdmin = (id: any, type: string) => {
    const reqUrl = "banks/actions/requestFullAccess";
    var response = sendRequest(reqUrl, {
      id: id,
      data: {
        type: type,
      },
    });
    response.then((res) => {
      if (res?.code == 200) {
        success("Request sent to admin successfully");
      } else {
        error("Error sending request to admin: " + res?.message);
      }
    });
  };
  const ProbationDateField = ({ ...props }) => {
    const record = useRecordContext();
    const [setProbation, setSetProbation] = React.useState(
      record?.iProbation == 1 ? 1 : 0
    );
    if (admin) {
      return (
        <Grid
          container
          spacing={2}
          sx={{
            mt: "0px",
            pt: "0px",
            "& .MuiGrid-item": { mt: "0px", pt: "0px" },
          }}
        >
          {admin && (
            <Grid item xs={12} sm={12}>
              <YesNoInput3
                source="iProbation"
                label="Is Probation?"
                defaultValue={record?.iProbation == 1 ? true : false}
                onChange={(e) => {
                  setSetProbation(e.target.value);
                }}
                readOnly={admin ? (isEdit ? false : true) : false}
              />
            </Grid>
          )}

          {admin && setProbation == 1 && (
            <>
              <Grid item xs={12} sm={6}>
                <DateInput
                  source="dProbationStartTime"
                  label="Probation Start Date"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DateInput
                  source="dProbationEndTime"
                  label="Probation End Date"
                  variant="outlined"
                  onChange={(event: any) => {
                    const value = event.target.value;
                    if (value) {
                      const startDate = new Date(
                        document.querySelector(
                          'input[name="dProbationStartTime"]'
                        )?.value
                      );
                      const endDate = new Date(value);
                      if (endDate < startDate) {
                        error("Probation End Date cannot be before Start Date");
                      }
                    }
                  }}
                />
              </Grid>
            </>
          )}
          {admin && (
            <Grid item xs={12} sm={12}>
              <SelectInput
                source="sAccess"
                label="Access"
                choices={[
                  { id: "business", name: "Business Products" },
                  { id: "personal", name: "Consumer Products" },
                  { id: "full", name: "Full Access" },
                ]}
                sx={{
                  "& .MuiFormLabel-root span span": { display: "none" },
                }}
                variant="outlined"
                fullWidth
                validate={[required()]}
                readOnly={admin ? (isEdit ? false : true) : false}
              />
            </Grid>
          )}
        </Grid>
      );
    } else {
      if (record?.iProbation == 1) {
        return (
          <Grid container sx={{ mt: "10px" }}>
            <HeaderLabelGridField
              title="Your institution is currently under probation"
              value=""
              dxs={1}
              tdxs={11}
            />
            <HeaderLabelGridField
              title="Start date"
              value={
                record?.dProbationStartTime
                  ? format(new Date(record?.dProbationStartTime), "MM/dd/yyyy")
                  : ""
              }
              dxs={10}
              tdxs={2}
            />
            <HeaderLabelGridField
              title="End date"
              value={
                record?.dProbationEndTime
                  ? format(new Date(record?.dProbationEndTime), "MM/dd/yyyy")
                  : ""
              }
              dxs={10}
              tdxs={2}
            />
            <Typography sx={{ mt: 2 }}>
              Click{" "}
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  sendRequestToAdmin(record?.id, "create");
                }}
                to={""}
              >
                here
              </Link>{" "}
              to request full access.
            </Typography>
          </Grid>
        );
      } else {
        const accessBussiness =
          record?.sAccess == "business" || record?.sAccess == "full"
            ? true
            : false;
        const accessPersonal =
          record?.sAccess == "personal" || record?.sAccess == "full";
        return (
          <>
            This institution has access to:
            {/* <>
              <Typography sx={{ mt: 2 }}>
                {accessBussiness ? (
                  <TaskAltIcon
                    sx={{
                      verticalAlign: "top",
                      fontSize: "18px",
                      mt: 0.1,
                      mr: 0.5,
                    }}
                  />
                ) : (
                  <RadioButtonUncheckedIcon
                    sx={{
                      verticalAlign: "top",
                      fontSize: "18px",
                      mt: 0.1,
                      mr: 0.5,
                    }}
                  />
                )}
                Business products
              </Typography>
            </> */}
            <>
              <Typography sx={{ mt: 2 }}>
                {accessPersonal ? (
                  <TaskAltIcon
                    sx={{
                      verticalAlign: "top",
                      fontSize: "18px",
                      mt: 0.1,
                      mr: 0.5,
                    }}
                  />
                ) : (
                  <RadioButtonUncheckedIcon
                    sx={{
                      verticalAlign: "top",
                      fontSize: "18px",
                      mt: 0.1,
                      mr: 0.5,
                    }}
                  />
                )}
                Consumer products
              </Typography>
            </>
            {/* <Typography sx={{ mt: 2 }}>
              Click{" "}
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  sendRequestToAdmin(record?.id, "change");
                }}
                to={""}
              >
                here
              </Link>{" "}
              to request change of access.
            </Typography> */}
          </>
        );
      }
    }
  };
  return (
    <SimpleForm toolbar={false}>
      <Box
        sx={{
          pt: 1,
          pb: 1,
          width: "100%",
          // backgroundColor: "#fff",
          height: `calc(100vh - 387px)`,
          minHeight: `calc(100vh - 387px)`,
          overflowY: "auto",
        }}
        className="bank_profile_info"
        id="bank_edit_profile_info"
      >
        <ProbationDateField />
      </Box>
    </SimpleForm>
  );
};

const AccessEdit = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { success, error, info } = useNotify();

  const Actions = () => (
    <TopToolbar>
      {!isEditing ? (
        <EditButton
          onClick={() => setIsEditing(true)}
          sx={{ width: "100px" }}
        />
      ) : (
        <Button
          label="Back"
          onClick={() => {
            setIsEditing(false);
          }}
          sx={{ width: "100px" }}
          startIcon={<ArrowBack />}
        />
      )}
    </TopToolbar>
  );

  const handleSuccess = () => {
    setIsEditing(false);
    success("updated successfully");
  };
  const admin = localStorage.getItem("authrole") == "admin" ? true : false;
  return (
    <Edit
      title="Access"
      // actions={<Actions />}
      actions={false}
      mutationOptions={{ onSuccess: handleSuccess }}
    >
      {<AccessEditForm isEdit={isEditing} admin={admin} />}
    </Edit>
  );
};

export default AccessEdit;
